import { useCdnRefreshToken } from '../useCdnRefreshToken';

export const useHistoricalDateRefreshToken = (
  selectedDate: string | null,
  onInvalidate?: (() => void) | null
): string | null => {
  return useCdnRefreshToken({
    active: Boolean(selectedDate),
    key: selectedDate,
    onInvalidate,
  });
};
